export default __webpack_public_path__ + "static/media/spotifyre.8e296601.png";